import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cicd/projects/website-frontend/src/components/posts/EventPageClient.js");
